import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setUserRoles } from "../redux/reducers/auth.reducer";
import { SecurityService } from "../../SharedModule/services/security";
import { Spinner } from "./Spinner";
import { TimeoutLogic } from "./../components/TimeoutLogic";
import { ForbiddenPage } from "../pages/ForbiddenPage";
import eventHandler from "../utils/eventHandler";
import { useReacquireToken } from "../hooks/useReacquireToken";

export const Auth = ({ children }: any) => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState({ loaded: false, auth: false });

  const getRoles = useCallback(async () => {
    const userRoles = await SecurityService.getUserRole();
    Array.isArray(userRoles) && dispatch(setUserRoles(userRoles));
    setStatus({
      loaded: true,
      auth: true,
    });
  }, [dispatch]);

  const loginAccess = useReacquireToken(getRoles);

  useEffect(() => {
    eventHandler.on("authLogin", () => {
      loginAccess();
    });

    loginAccess();

    return () => {
      eventHandler.remove("authLogin", null);
    };
  }, [dispatch, loginAccess]);

  return (
    <>
      {status.auth && <TimeoutLogic />}
      {status.loaded ? (
        status.auth ? (
          children
        ) : (
          <ForbiddenPage />
        )
      ) : (
        <div className="position-absolute vh-100 vw-100 top-0 start-0">
          <Spinner
            style={{
              left: "50%",
              top: "50%",
              position: "absolute",
              transform: "translate(-15px, -15px)",
            }}
          />
        </div>
      )}
    </>
  );
};
